import {Observable, Subject} from "rxjs";
import {Injectable, OnDestroy} from "@angular/core";

@Injectable()
export class UnsubscribeOnDestroy implements OnDestroy{

  protected constructor() {}
  private _destroy: Subject<void> = new Subject<void>();

  destroy$: Observable<void> = this._destroy.asObservable();

  ngOnDestroy(): void {
    this._destroy.next();
    this._destroy.complete();
    this._destroy.unsubscribe();
  }

}
